import React from "react";
import { Alert, Dropdown, Button, OverlayTrigger, Tooltip, ToggleButton, ButtonGroup } from "react-bootstrap";
import { getDataReader, RPWDataReader, XMLJSON } from "../../livedataFuncs";
import { DropdownArrayObj } from "../fileToolbarConsts";
import { NavFileContainerRightSideType, RightDrawerOption } from "../fileToolbarTypes";
import { MainNoteItems } from "./fileToolBarNoteComponent";
import { calculateNumberOfNotes } from "./fileToolbarNotefuncs";
import { MainNoteItemTextBox } from "./fileToolBarNoteTextArea";
import { lddStateObject } from "../../redux/reducer";
import { connect } from "react-redux";
import { PreferenceDispatch } from "../../redux/actions";
import DropdownToggle from "../../Components/DropdownToggle";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IBaseProps { }
interface IBaseState {
    page: NavFileContainerRightSideType | undefined;
    show: boolean;
    sidebarshow: string;
}

abstract class Notebase<P extends IBaseProps, S extends IBaseState> extends React.Component<P, S> {
    constructor(props: P | Readonly<P>) {
        super(props);
        this.state = {
            page: undefined,
            show: false,
            sidebarshow: null
        } as Readonly<S>
    }
}

interface INoteRightSideProps extends IBaseProps {
    datarootContainer: any,
    sidebarshow: string;
    toggleState: boolean;
    pinnedTab: RightDrawerOption;
    PreferenceDispatch: typeof PreferenceDispatch
    noteDropdownTarget?: string | null;
    setNoteDropdownTarget?: (noteDropdownTarget: string | null) => void;
}

interface INoteRightSideState extends IBaseState {
    noteDropdownState: string,
    addNoteState: boolean,
    showReply: boolean,
    showDeleteNoteAlert: boolean,
    indexCounter: number,
    showNoteBanner: boolean,
    showOpenNotesOnly: boolean,
}

class NoteRightSide extends Notebase<INoteRightSideProps, INoteRightSideState> {
    mainNoteItems: XMLJSON[];
    constructor(props: INoteRightSideProps | Readonly<INoteRightSideProps>) {
        super(props);
        let MainNoteInfo: XMLJSON[];
        if (this.props.datarootContainer?.dataRoot) {
            const DataReaderObj = getDataReader(this.props.datarootContainer?.dataRoot);
            MainNoteInfo = DataReaderObj.getMainNoteInformation();
            MainNoteInfo = MainNoteInfo.reverse();
        }
        this.mainNoteItems = MainNoteInfo;

        this.state = {
            sidebarshow: this.props.sidebarshow,
            noteDropdownState: "All",
            addNoteState: false,
            showReply: false,
            page: undefined, // from IBaseState
            show: undefined, // from IBaseState
            showDeleteNoteAlert: false,
            indexCounter: 0,
            showNoteBanner: false,
            showOpenNotesOnly: true,
        }
    }

    componentWillUnmount() {
        this.setState({
            addNoteState: false
        });
    }

    handlePrint = () => {
        window.print()
    };

    formatDate = (dateString) => {
        const date = new Date(dateString);
        const formattedDate = `${('0' + date.getDate()).slice(-2)}/${date.toLocaleString('en-US', { month: 'short' })}/${date.getFullYear()}, ${('0' + (date.getHours() % 12 || 12)).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}${date.getHours() >= 12 ? ' PM' : ' AM'}`;
        return formattedDate;
    }

    getNoteFileNumber = () => {
        const processor: RPWDataReader = getDataReader(this.props.datarootContainer.dataRoot);
        return processor.getFileNumber()
    }

    getMainNoteItems = () => {
        if(this.props.datarootContainer?.dataRoot) {
            const DataReaderObj: RPWDataReader = getDataReader(this.props.datarootContainer?.dataRoot);
            const MainNoteInfo: XMLJSON[] = DataReaderObj.getMainNoteInformation();
            this.mainNoteItems = MainNoteInfo.reverse();
        }
    }

    setAddNote = (value: boolean) => {
        this.getMainNoteItems();
        this.setState({
            addNoteState: value
        });
    }

    setShowReplyState = (changeState: boolean) => {
        this.setState({
            showReply: changeState,
        })
    }
    setDeleteNoteAlertState = (changeState: boolean) => {
        this.setState({
            showDeleteNoteAlert: changeState,
        })
    }
    setIndexCounterState = (changeState: number) => {
        this.setState({
            indexCounter: changeState,
        })
    }
    componentDidUpdate(prevProps: Readonly<INoteRightSideProps>, _prevState: Readonly<INoteRightSideState>, _snapshot?: any): void {
        if (prevProps.sidebarshow !== 'Notes' && this.state.showDeleteNoteAlert) {
            this.setDeleteNoteAlertState(false);
        }
        // Reset addNoteState when the sidebarshow changes
        if (prevProps.sidebarshow !== this.props.sidebarshow) {
            this.setState({ addNoteState: false });
        }

        if (this.props.noteDropdownTarget && prevProps.noteDropdownTarget !== this.props.noteDropdownTarget) {
            const target = this.props.noteDropdownTarget;
            const isValidTarget = DropdownArrayObj.mainScreenNameIndex[target] !== undefined;
            if (isValidTarget && this.state.noteDropdownState !== target) {
                this.setState({ noteDropdownState: target });
            }
            this.props.setNoteDropdownTarget?.(null);
        }
    }

    pinClickHandler = () => {
        if (this.props.pinnedTab === "Notes") {
            // unpin
            this.props.PreferenceDispatch("PinRightSideTab", "toggle");
        } else {
            // pin
            this.props.PreferenceDispatch("PinRightSideTab", "Notes");
        }
    }

    getFilteredNotes = () => {
        if (!this.mainNoteItems) return [];
        
        const arrayPosition = DropdownArrayObj.mainScreenNameIndex[this.state.noteDropdownState];
        const filteredNotes = [];
        
        this.mainNoteItems.forEach(note => {
            // Check if note matches the dropdown filter
            if (this.state.noteDropdownState === "All" || 
                note.attributes.mainScreenName === DropdownArrayObj.mainScreenNames[arrayPosition]) {
                
                // Check if note matches the resolved/unresolved filter
                if (this.state.showOpenNotesOnly) {
                    // Show only unresolved notes
                    if (note.attributes.reactIsCheckMarked !== "1") {
                        filteredNotes.push(note);
                    }
                } else {
                    // Show all notes
                    filteredNotes.push(note);
                }
            }
        });
        
        return filteredNotes;
    }

    openNotesInNewWindow = () => {
        const fileNumber = this.getNoteFileNumber();
        const filteredNotes = this.getFilteredNotes();
        
        let htmlContent = `
        <html>
        <head>
            <style>
                body { font-family: Arial, sans-serif; }
                h1 { font-size: 24px; margin-bottom: 20px; text-align: left; }
                .container { position: absolute; right: 0px; top: 0px}
                .table-container { position: relative; width: 100%; max-width: 1140px; margin: 10px auto; }
                table { border-collapse: collapse; width: 100%; max-width: 1140px; margin: 10px auto; position: relative; }
                th, td { border: 1px solid #ddd; padding: 8px; }
                th { background-color: #f2f2f2; text-align: left }
                .print-button { background-color: #006A99; color: #fff; border: none; padding: 10px 20px; font-size: 16px; cursor: pointer; border-radius: 20px; }
                .print-button:hover { background-color: #005780; }
                .reply { margin-left: 20px; }
                @media print { .print-button { display: none; }}
            </style>
        </head>
        <body>
            <div class="table-container">
            <h1>Print Notes for File: ${fileNumber}</h1>
            <div class="container">
                <button class="print-button" onclick="window.print()">Print</button>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>User</th>
                        <th>Note</th>
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
        `;
        
        filteredNotes.forEach(note => {
            htmlContent += `
                <tr>
                    <td>${note.attributes.DisplayName}</td>
                    <td class="note-text">${note.attributes.text.replace(/--/g, '\n--').replace(/\n/g, '<br>')}</td>
                    <td>${this.formatDate(note.attributes.CreateDate)}</td>
                </tr>
            `;
            if (note.children && note.children.length > 0) {
                note.children.forEach(reply => {
                    htmlContent += `
                        <tr class="reply">
                            <td>[Re]:${reply.attributes.DisplayName}</td>
                            <td class="note-text">${reply.attributes.text.replace(/--/g, '\n--').replace(/\n/g, '<br>')}</td>
                            <td>${this.formatDate(reply.attributes.CreateDate)}</td>
                        </tr>
                    `;
                });
            }
        });
        
        htmlContent += `
                    </tbody>
                </table>
                </div>
            </body>
        </html>
        `;
        
        const notesWindow = window.open(' ', '_blank');
        if (notesWindow) {
            notesWindow.document.write(htmlContent);
            notesWindow.document.close();
            notesWindow.print()
        } else {
            alert('Allow pop-ups to open the notes in a new window.');
        }
    }    

    toggleOpenNotesFilter = () => {
        this.setState(prevState => ({
            showOpenNotesOnly: !prevState.showOpenNotesOnly
        }));
    }

    render() {
        let drawerClasses = ''
        if (this.props.sidebarshow === 'Notes' && this.props.toggleState === true) {
            drawerClasses = 'open';
            this.getMainNoteItems();
        }

        let lengthOfNodes = calculateNumberOfNotes(this.mainNoteItems, this.state.noteDropdownState, this.state.showOpenNotesOnly);

        return (
            <>
                <div className={"toolbar-content " + drawerClasses} key={'main-notes'}>
                    <div className="toolbar-header">
                        <h2>
                            Notes
                            <OverlayTrigger placement="bottom" delay={200} overlay={
                                <Tooltip>{this.props.pinnedTab === "Notes" ? `Unset default` : `Set as default`}</Tooltip>
                            }>
                                <i className={`${this.props.pinnedTab === "Notes" ? "fa-solid" : "fa-regular"} fa-thumbtack`}
                                    onClick={this.pinClickHandler} />
                            </OverlayTrigger>
                        </h2>

                        <div>
                            <i className="fa-solid fa-print" title="Print Notes" onClick={() => this.openNotesInNewWindow()}></i>
                        </div>
                    </div>

                    <div className="toolbar-filter">
                        <Button variant="primary" size="sm" onClick={() => {
                                this.setState({
                                    addNoteState: true
                                });
                                this.setDeleteNoteAlertState(false);
                            }}>
                            <i title="Add Note" className="fa-solid fa-plus"></i>
                            Note
                        </Button>

                        <div>
                            <ButtonGroup>
                                <ToggleButton
                                    id="all-tab"
                                    type="radio"
                                    variant={!this.state.showOpenNotesOnly ? "primary" : "outline-primary"}
                                    name="tab"
                                    value="All"
                                    checked={this.state.showOpenNotesOnly === false}
                                    onChange={() => this.setState({ showOpenNotesOnly: false })}
                                >
                                    All
                                </ToggleButton>
                                <ToggleButton
                                    id="unresolved-tab"
                                    type="radio"
                                    variant={this.state.showOpenNotesOnly ? "primary" : "outline-primary"}
                                    name="tab"
                                    value="Unresolved"
                                    checked={this.state.showOpenNotesOnly === true}
                                    onChange={() => this.setState({ showOpenNotesOnly: true })}
                                >
                                    Unresolved
                                </ToggleButton>
                            </ButtonGroup>

                            <this.NoteOptionDropdown></this.NoteOptionDropdown>
                        </div>
                    </div>
                    
                    <div className="toolbar-body">

                        {this.state.showDeleteNoteAlert &&
                            <Alert key="danger" variant='danger'>
                                Note Removed
                                <i className="fa fa-times note-alert-dismiss" aria-hidden="true"
                                    onClick={() => this.setDeleteNoteAlertState(false)}></i>
                            </Alert>
                        }
                        
                        {lengthOfNodes === 0 && !this.state.showDeleteNoteAlert &&
                            <Alert>Click '+' to add a note.</Alert>
                        }

                        {this.state.addNoteState &&
                            <MainNoteItemTextBox
                                index={this.state.indexCounter}
                                displayBoxHandler={this.setAddNote}
                                showReplyBoxMessage={"Add new note here.."}
                                ReplyBoxType={"Add"}
                                dataroot={this.props.datarootContainer?.dataRoot}
                                noteDropdownState={this.state.noteDropdownState} />
                        }

                        {(lengthOfNodes > 0 || this.state.noteDropdownState === 'All') &&
                            <>
                                {this.mainNoteItems?.map((object: XMLJSON, index: number) =>
                                    <MainNoteItems
                                        node={object}
                                        index={index}
                                        noteDropdownState={this.state.noteDropdownState}
                                        showOpenNotesOnly={this.state.showOpenNotesOnly}
                                        dataroot={this.props.datarootContainer?.dataRoot}
                                        setDeleteNoteState={this.setDeleteNoteAlertState}
                                        key={`main-note-item-${index}`}
                                    />
                                )}
                            </>
                        }
                    </div>
                </div>
            </>
        )
    }

    NoteOptionDropdown = () => {
        return (
            <>
                <Dropdown style={{display:'inline-block'}}>
                    <Dropdown.Toggle as={DropdownToggle} >
                        {this.state.noteDropdownState}
                    </Dropdown.Toggle>

                    <Dropdown.Menu >
                        {
                            Object.keys(DropdownArrayObj.mainScreenNameIndex).map(option => {
                                return (
                                    <Dropdown.Item key={option} onClick={() => {
                                        this.setState({
                                            noteDropdownState: option
                                        })
                                        this.setDeleteNoteAlertState(false);
                                    }
                                    }>{option}</Dropdown.Item>
                                )
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>
            </>
        );
    }
}

const mapStateToProps = (state: lddStateObject) => {
    const { Preference } = state
    return { pinnedTab: Preference["PinRightSideTab"] }
}
const mapDispatchToProps = {
    PreferenceDispatch
}

export default connect(mapStateToProps, mapDispatchToProps)(NoteRightSide) 